'use client';

import { Flex, Skeleton, SkeletonText } from '@chakra-ui/react';

const ProductFinderSkeleton = () => {
  return (
    <>
      <Flex
        direction={{ base: 'column', tablet: 'row' }}
        gap={{ base: 8, tablet: 14, desktop: 16 }}
        justifyContent="space-between"
        width="100%"
      >
        <Flex direction="column" flex="1" gap={4}>
          <SkeletonText noOfLines={1} width="120px" />
          <Skeleton height="40px" width="100%" />
        </Flex>

        <Flex direction="column" flex="1" gap={4}>
          <SkeletonText noOfLines={1} width="120px" />
          <Skeleton height="40px" width="100%" />
        </Flex>

        <Flex direction="column" flex="1" gap={4}>
          <SkeletonText noOfLines={1} width="120px" />
          <Skeleton height="40px" width="100%" />
        </Flex>
      </Flex>

      <Skeleton height="48px" width={{ base: 'full', tablet: '332px' }} alignSelf="center" borderRadius="8px" />
    </>
  );
};

export default ProductFinderSkeleton;
